import axios from 'axios'
import { Decode } from '@/services'

const GetToken = () => {
  if (localStorage.getItem('authNSG') !== null) {
    const oneData = JSON.parse(Decode.decode(localStorage.getItem('authNSG')))
    const auth = {
      headers: { Authorization: `Bearer ${oneData.user.access_token}` }
    }
    return auth
  } else {
    const auth = ''
    return auth
  }
}

export default {
  async axiosGetCategory (val) {
    // const data = val
    const auth = await GetToken()
    try {
      var response = await axios.get(`${process.env.VUE_APP_BACK_END}list_category`, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetMainCategory (val) {
    // const data = val
    // const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}category/show_list_main_category`, val)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetMainAndSubCategory (val) {
    // const data = val
    // const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}category/show_list_all_category`, val)
      return response.data
    } catch (error) {
      return error.response.data
    }
  }
}
